import { Column } from "../model/Column";
import { FlexComponent } from "typings/flexFramework/FlexComponent";

export class BaseColumnDecorator implements Column {
  public wrappedColumn: Column;
  public modules: FlexComponent[];
  public width: string;

  public constructor(column: Column) {
    this.wrappedColumn = column;
    this.modules = column.modules;
    this.width = column.width;
  }

  /* istanbul ignore next */
  public getColumnsToRender() {
    return this.wrappedColumn.getColumnsToRender();
  }
}
